var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"paths-container"}},_vm._l((_vm.paths),function(path){return _c('PathButton',_vm._g({key:path,attrs:{"path":path,"activePath":_vm.activePath}},{ handleSelectPath: _vm.handleSelectPath }))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }